module.exports = __webpack_public_path__ + "img/signup_carousel_3.d56f3f3d.svg";